import * as React from 'react';
import { Subscription } from 'rxjs';

export class SubscribingEntity {
  private readonly subscriptions: Subscription[] = [];

  addSubscriptionToCloseOnDestroy(subscription: Subscription): void {
    this.subscriptions.push(subscription);
  }

  onDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      try {
        subscription.unsubscribe();
      } catch (e) {
        console.error(e);
      }
    });
  }
}

export function useSubscribingEntity(): SubscribingEntity {
  const [subscribingEntity] = React.useState(() => new SubscribingEntity());

  React.useEffect(() => {
    return () => {
      subscribingEntity.onDestroy();
    };
  }, [subscribingEntity]);

  return subscribingEntity;
}
